import React from "react";
import Modal from "@insightfulscience/atomic-react/Modal";
import ModalHead from "@insightfulscience/atomic-react/Modal/Head";
import ModalBody from "@insightfulscience/atomic-react/Modal/Body";
import { ModalClose } from "@insightfulscience/smart-react/Modals/ModalClose";
import { useModal } from "@insightfulscience/smart-react/Modals/Engine";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Button from "@insightfulscience/atomic-react/Button";
import Link from "@insightfulscience/atomic-react/Link";
import { setProtocol } from "./actions"; // TODO: brake the cycle imports
import { ROUTE_FREE_TRIAL, ROUTE_SNAPGENE_VIEWER } from "../../routes";

const OpenInSnapgeneModal = ({ ...props }) => {
	const { close } = useModal();
	return (
		<Modal overlay>
			<ModalHead>
				<ModalClose onClick={() => close(false)} />
			</ModalHead>
			<ModalBody>
				<Paragraph sx={{ textAlign: "center" }} spacing={{ mt: 0, mb: 6 }}>
					Please choose an application for opening sequence files.
				</Paragraph>
				<Row mx my utility={{ justify: "center" }}>
					<Col sm={12} lg={4} sx={{ textAlign: "center" }}>
						<Button size="s" onClick={() => setProtocol("snapgene", close, props)}>
							Open with SnapGene
						</Button>
					</Col>
					<Col sm={12} lg={4} sx={{ textAlign: "center" }}>
						<Button
							styleType="secondary"
							isOutline2
							size="s"
							onClick={() => setProtocol("snapgeneviewer", close, props)}
						>
							Open with SnapGene Viewer
						</Button>
					</Col>
				</Row>
				<Row utility={{ justify: "center" }}>
					<Col md={8}>
						<Paragraph sx={{ textAlign: "center" }} spacing={{ mt: 10 }}>
							Don’t have either application?
							<br />
							{/* Do not change to NextLink, it breaks the modal, as for some reason we create modals outside of next context */}
							<Link href={ROUTE_FREE_TRIAL}>Download SnapGene</Link> or{" "}
							<Link href={ROUTE_SNAPGENE_VIEWER}>SnapGene Viewer</Link>.
						</Paragraph>
					</Col>
				</Row>
			</ModalBody>
		</Modal>
	);
};

export default OpenInSnapgeneModal;
